export default {
  createHeader: 'Utwórz tag zdarzenia',
  editHeader: 'Edytuj tag zdarzenia',
  duplicateDisplayName: 'Tag o tej nazwie już istnieje.',
};
